export default __webpack_public_path__ + "static/FalabellaLogo-815ee98e668ecdaf6fbbbbf7ae9c2d93.png";